import React from "react";
import {
  ContainerMoreContact,
  ContentMoreContact,
  CardMoreContact,
  Face1,
  Face2,
  PortfolioShow,
} from "./StyledComponents/CardHover.style";

const MovieCard = ({ title, content, projetVideo }) => {
  return (
    <>
      <ContainerMoreContact>
        <CardMoreContact>
          <Face1>
            <ContentMoreContact>
              <h3>{title}</h3>
              <p>{content}</p>
            </ContentMoreContact>
          </Face1>
          <Face2>
            <PortfolioShow src={projetVideo} controls />
          </Face2>
        </CardMoreContact>
      </ContainerMoreContact>
    </>
  );
};

export default MovieCard;
